import React from 'react';

export const SkeletonGroupContext = React.createContext();
